import { render, staticRenderFns } from "./PD4040.vue?vue&type=template&id=116d21ca&scoped=true&"
import script from "./PD4040.vue?vue&type=script&lang=js&"
export * from "./PD4040.vue?vue&type=script&lang=js&"
import style0 from "./PD4040.vue?vue&type=style&index=0&id=116d21ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116d21ca",
  null
  
)

export default component.exports